"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ContextConsumer = exports.ContextProvider = exports.Context = void 0;

var _react = _interopRequireDefault(require("react"));

var Context = /*#__PURE__*/_react["default"].createContext();

exports.Context = Context;
var ContextProvider = Context.Provider;
exports.ContextProvider = ContextProvider;
var ContextConsumer = Context.Consumer;
exports.ContextConsumer = ContextConsumer;
var _default = Context;
exports["default"] = _default;